const custom_profile_fields = {
    entity_not_exists_with_names: 'No se pueden encontrar entidades con los nombres dados: {{names}}',
    invalid_min_max_input: 'Entrada de mínimo y máximo no válida.',
    invalid_options: 'Opciones de campo no válidas.',
    invalid_regex_format: 'Formato de expresión regular no válido.',
    invalid_address_parts: 'Partes de dirección no válidas.',
    invalid_fullname_parts: 'Partes de nombre completo no válidas.',
    name_exists: 'Ya existe un campo con el nombre proporcionado.',
    conflicted_sie_order: 'Valor de orden de campo en conflicto para la experiencia de inicio de sesión.',
    invalid_name: 'Nombre de campo no válido, solo se permiten letras o números, distingue entre mayúsculas y minúsculas.',
    name_conflict_sign_in_identifier: 'Nombre de campo no válido. "{{name}}" es una clave reservada para el identificador de inicio de sesión.',
    name_conflict_custom_data: 'Nombre de campo no válido. "{{name}}" es una clave reservada para datos personalizados.',
    name_required: 'El nombre del campo es obligatorio.',
};
export default Object.freeze(custom_profile_fields);
